$(document).ready(function () {
    // Update submission report form when selecting assignment, and reset related year groups
    const $submissionReportForm = $('form[name="submissions-report-form"]');
    const $assignment = $submissionReportForm.find('select[name="assignment"]');
    const $group = $submissionReportForm.find('select[name="group"]');

    $assignment.on('change', function () {
        $group.val('');
        $submissionReportForm.submit();
    });

    $group.on('change', function () {
        $submissionReportForm.submit();
    });

    $('#submission-report-submission-detail').on('show.bs.modal', function (e) {
        var submission = $(e.relatedTarget).data('submission');
        $('.student-name').empty().append(submission.student.firstname + ' ' + submission.student.lastname);
        $('p.student-submission').empty().append('<i class="' + File.getIcon(submission.uri.split('.', 2)[1]) + '"></i>' + submission.title + '<br>' +
            '<small>Uploaded:' + dayjs(parseInt(submission.createddate * 1000)).format(LONGDATE + ' ' + TIME) + '</em></small>' + '<br><br>' +
            '<a href="eportfolio/downloadfile/' + submission.id + '" class="btn btn-sm btn-default" role="button">' +
            '<i class="' + FontAwesome.prefix('solid', 'download') + '"></i>Download ' + File.getReadableExtension(submission.uri.split('.', 2)[1]) +
            '<em>(' + File.getReadableFileSizeString(submission.size) + ')</em>' +
            '</a>');

        $('ul.tutor-feedback').empty();
        if (submission.feedback) {
            let releaseToStudent = parseInt(submission.feedback.returntostudent, 10) === 1
                ? '(Released To Student)'
                : '(NOT Released To Student)';

            $('ul.tutor-feedback').append(
                '<li class="heading">' +
                '<i class="' + FontAwesome.prefix('regular', 'comments') + '"></i>' +
                'Tutor Feedback ' + submission.feedback.lastmodifiedby_realname + ' ' + releaseToStudent +
                '</li>' +
                '<li>' +
                '<p class="text-right">' +
                '<small>Posted: ' + dayjs(parseInt(submission.feedback.createddate) * 1000).format(LONGDATE + ' ' + TIME) +
                '</small>' +
                '</p>' +
                '<p>' + submission.feedback.feedback.replace('\n', '<br>') + '</p>' +
                '</li>'
            );
        }
    });

    $('#submission-report-delete').on('show.bs.modal', function (e) {
        var submission = $(e.relatedTarget).data('submission');
        $('.student-name').empty().append(submission.student.firstname + ' ' + submission.student.lastname);
        $('.delete-submission').empty().append('<h4 class="alert-heading">Warning</h4>' +
            '<p>You are about to delete the submission: ' + submission.title + '. Are you sure you wish to continue?</p><br>');
        $('#submission-id').attr('href', 'eportfolio/deletefile/' + submission.id);
    });

    // Keyword search on submissions report list
    var submissionlist = $('#submission-list');
    $('.filterinput')
        .change(function () {
            var submissionfilter = $(this).val();
            if (submissionfilter) {
                $matches = $(submissionlist).find('span.reportdetails:Contains(' + submissionfilter + ')').parent();
                $('li', submissionlist).not($matches).hide();
                $matches.show();
            } else {
                $(submissionlist).find('li').show();
            }
            return false;
        })
        .keyup(function () {
            $(this).change();
        });

    $('.releaseStudentFeedback').click(function () {
        if (confirm('Are you sure you want to release feedback to the students?')) {
            $(this).prop('disabled', true).html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Releasing Feedback to Students...');
        } else {
            return false;
        }
    });
});
